const coachingsCalls = {
  api_coachings({ dispatch }) {
    const callId = `poker/coaching/lessons/`
    dispatch('api_call', {
      endpoint: callId,
      hasCancel: false,
      mutation: 'api_coachings',
      dissIfSameCallInProgress: true,
      cacheCancelIdPart: callId,
      callId,
    })
  },
}

export default coachingsCalls
